<template>
  <div class="auth-wrapper-provider">
    <b-form @submit.prevent="submit" class="flex-center">
      <AuthWrapper
        rightIcon="arrow-right"
        @handleRightIcon="goToLogin"
        :label="$lang.authInfo"
      >
        <template #main>
          <b-row>
            <b-col cols="12" class="margin-bottom-16">
              <Input
                :title="$lang.username"
                :label="$lang.username"
                :placeholder="$lang.username"
                :value="form.username"
                name="username"
                id="username"
                type="text"
                :disabled="true"
                :vuelidateObj="$v.form.username"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
              <PasswordInputWithRandomPassword
                :title="$lang.password"
                :label="$lang.password"
                :placeholder="$lang.password"
                :infoTooltip="$lang.passwordFormatTooltip"
                :hasPasswordWithSymbol="true"
                :value="form.password"
                name="password"
                id="password"
                type="password"
                :vuelidateObj="$v.form.password"
                rowClass="width-percent-100"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <b-col cols="12">
              <div
                class="color-complementary-400 font-size-16 margin-y-16 padding-top-16 border--solid border--top border--complementary-100"
              >
                {{ $lang.person_info }}
              </div>
              <Input
                :label="$lang.national_code"
                :placeholder="$lang.national_code"
                :value="form.nationalCode"
                name="nationalCode"
                id="nationalCode"
                type="text"
                :minLength="lengthNumber10"
                :maxLength="lengthNumber10"
                :disabled="hasNationalCode"
                :vuelidateObj="$v.form.nationalCode"
                :hasLeftIcon="true"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <b-col cols="12">
              <Input
                :label="$lang.name"
                :placeholder="$lang.name"
                :value="form.name"
                name="name"
                id="name"
                type="text"
                :minLength="lengthNumber3"
                :maxLength="lengthNumber64"
                :vuelidateObj="$v.form.name"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <b-col cols="12">
              <Input
                :label="$lang.family"
                :placeholder="$lang.family"
                :value="form.family"
                name="family"
                id="family"
                type="text"
                :minLength="lengthNumber3"
                :maxLength="lengthNumber64"
                :vuelidateObj="$v.form.family"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <b-col
              cols="6"
              md="6"
              class="position-relative padding-left-4"
              v-if="pathOr(null, ['birth_date'], extraFields)"
            >
              <DatePicker
                :label="$lang.birth_date"
                :placeholder="$lang.birth_date"
                :value="form.birthDate"
                name="birthDate"
                id="birthDate2"
                type="date"
                :popover="true"
                :simple="true"
                :autoSubmit="true"
                :vuelidateObj="$v.form.birthDate"
                :max="new Date() | moment('YYYY/MM/DD HH:mm:ss')"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <b-col
              cols="6"
              md="6"
              class="position-relative padding-right-4"
              v-if="pathOr(null, ['education_grade'], extraFields)"
            >
              <Dropdown
                :label="$lang.education_grade"
                :placeholder="$lang.education_grade"
                :value="form.educationGrade"
                :options="educationGradeOptions"
                name="educationGrade"
                id="educationGrade"
                :vuelidateObj="$v.form.educationGrade"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <b-col
              cols="12"
              class="position-relative"
              v-if="pathOr(null, ['sokonat_city'], extraFields)"
            >
              <Dropdown
                :label="$lang.sokonat_city"
                :placeholder="$lang.sokonat_city"
                :value="form.sokonatCity"
                name="sokonatCity"
                id="sokonatCity"
                :vuelidateObj="$v.form.sokonatCity"
                :asyncSearch="getLocationPublicCombo"
                :insideFeature="true"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <b-col
              cols="6"
              md="6"
              class="position-relative padding-left-4"
              v-if="pathOr(null, ['job_info'], extraFields)"
            >
              <Dropdown
                :label="$lang.job_level"
                :placeholder="$lang.job_level"
                :value="form.jobLevel"
                name="jobLevel"
                id="jobLevel"
                :vuelidateObj="$v.form.jobLevel"
                :options="jobLevelOptions"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <b-col
              cols="6"
              md="6"
              class="position-relative padding-right-4"
              v-if="pathOr(null, ['job_info'], extraFields)"
            >
              <Dropdown
                :label="$lang.job_category"
                :placeholder="$lang.job_category"
                :value="form.jobCategory"
                name="jobCategory"
                id="jobCategory"
                :vuelidateObj="$v.form.jobCategory"
                :options="jobCategoryOptions"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <slide-y-up-transition>
              <b-col
                cols="12"
                v-if="
                  pathOr(null, ['job_info'], extraFields) &&
                  pathOr(null, ['id'], form.jobCategory) === 8
                "
              >
                <Input
                  :label="$lang.job_category"
                  :placeholder="$lang.job_category"
                  :value="form.otherJobCategory"
                  name="otherJobCategory"
                  id="otherJobCategory"
                  type="textarea"
                  :minLength="lengthNumber3"
                  :maxLength="lengthNumber256"
                  :vuelidateObj="$v.form.otherJobCategory"
                  @input="input"
                  @focus="resetValidation"
                  @blur="checkValidation"
                />
              </b-col>
            </slide-y-up-transition>
            <b-col cols="12" class="flex-between">
              <span class="font-size-12 color-complementary-300">{{
                $lang.gender
              }}</span>
              <div class="flex-between">
                <ButtonCheckbox
                  class="margin-left-4"
                  rightIcon="human-male"
                  :text="$lang.male"
                  value="1"
                  :active="form.gender === 1"
                  @click="genderClicked"
                />
                <ButtonCheckbox
                  class="margin-right-4"
                  rightIcon="human-female"
                  :text="$lang.female"
                  value="2"
                  :active="form.gender === 2"
                  @click="genderClicked"
                />
              </div>
            </b-col>
            <b-col cols="12" class="margin-bottom-22">
              <FeedbackMessages
                :label="$lang.gender"
                :state="$v.form.gender.$dirty ? !$v.form.gender.$error : null"
                :vuelidateObj="$v.form.gender"
              />
            </b-col>
            <b-col
              cols="12"
              class="margin-bottom-16"
              v-if="pathOr(false, ['profile_image'], extraFields)"
            >
              <AttachmentWotUploader
                :label="$lang.profile_upload"
                :resourceName="resourceName"
                :resourceValue="resourceValue"
                :uploaderConfig="uploaderConfig"
                uploaderName="pre_register"
                @hasFile="updateHasFile"
                @success="updateSuccessUploaded"
              />
            </b-col>
          </b-row>
        </template>
        <template #button>
          <b-row>
            <b-col cols="12">
              <Button
                class="w-100"
                contentClass="justify-content-center"
                variant="primary"
                :text="$lang.submit"
                :loading="loading"
                type="submit"
                @click="submit"
              />
            </b-col>
          </b-row>
        </template>
      </AuthWrapper>
    </b-form>
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { AuthWrapper } from "@/components/re-design";
import AttachmentWotUploader from "@/components/re-design/uploader/AttachmentWotUploader.vue";
import {
  Input,
  PasswordInputWithRandomPassword,
  DatePicker,
  Dropdown,
  ButtonCheckbox,
  FeedbackMessages,
  Button,
} from "@/components/re-design/forms";
import {
  required,
  minLength,
  maxLength,
  numeric,
  requiredIf,
} from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { goToRoute, renderEumOptions, toastAlert } from "@/shared/utils";
import { getLocationPublicCombo } from "@/services";
import { setPreRegister } from "@/modules/auth/services";
import { mapGetters } from "vuex";

export default {
  mixins: [inputMixin],
  components: {
    AuthWrapper,
    Input,
    PasswordInputWithRandomPassword,
    DatePicker,
    Dropdown,
    ButtonCheckbox,
    FeedbackMessages,
    AttachmentWotUploader,
    Button,
  },
  validations() {
    return {
      form: {
        username: {},
        password: { required },
        nationalCode: {
          required: requiredIf(() => !this.hasNationalCode),
          numeric,
          minLength: minLength(this.lengthNumber10),
          maxLength: maxLength(this.lengthNumber10),
        },
        name: {
          required,
          minLength: minLength(this.lengthNumber3),
          maxLength: maxLength(this.lengthNumber64),
        },
        family: {
          required,
          minLength: minLength(this.lengthNumber3),
          maxLength: maxLength(this.lengthNumber64),
        },
        birthDate: {
          required: requiredIf(() =>
            pathOr(null, ["birth_date"], this.extraFields)
          ),
        },
        educationGrade: {
          required: requiredIf(() =>
            pathOr(null, ["education_grade"], this.extraFields)
          ),
        },
        sokonatCity: {
          required: requiredIf(() =>
            pathOr(null, ["sokonat_city"], this.extraFields)
          ),
        },
        jobLevel: {
          required: requiredIf(() =>
            pathOr(null, ["job_info"], this.extraFields)
          ),
        },
        jobCategory: {
          required: requiredIf(() =>
            pathOr(null, ["job_info"], this.extraFields)
          ),
        },
        otherJobCategory: {
          required: requiredIf(
            () =>
              pathOr(null, ["job_info"], this.extraFields) &&
              pathOr(false, ["id"], this.form.jobCategory) === 8
          ),
        },
        gender: { required, numeric },
      },
    };
  },
  data() {
    return {
      loading: false,
      form: {
        username: null,
        password: null,
        nationalCode: null,
        name: null,
        family: null,
        birthDate: null,
        educationGrade: null,
        sokonatCity: null,
        jobLevel: null,
        jobCategory: null,
        otherJobCategory: null,
        gender: null,
      },
      resourceName: "person",
      resourceValue: null,
      successUploaded: false,
      hasFile: false,
      submitAction: "",
      submitRouteName: "",
      submitMessage: null,
      uploaderConfig: {
        // hard code data for uploader without token
        uploaders: [
          {
            name: "pre_register",
            items: [10],
          },
        ],
        attachments: [
          {
            id: 10,
            category_name: "attachment_type_person",
            max_upload: 1,
            types: [
              {
                ext: ["jpg", "jpeg", "png", "bmp"],
                title: "عکس",
                max_size: 10240,
                min_res: 100,
              },
            ],
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("auth", [
      "currentCourse",
      "preRegisterUsername",
      "hasNationalCode",
      "nationalCodePreview",
      "extraFields",
    ]),
    educationGradeOptions() {
      return renderEumOptions("education_grade", true);
    },
    jobLevelOptions() {
      return renderEumOptions("person_company_job_level", true);
    },
    jobCategoryOptions() {
      return renderEumOptions("job_category", true);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    goToRoute,
    renderEumOptions,
    getLocationPublicCombo,
    goToLogin() {
      goToRoute("auth", {}, {}, false);
    },
    updateHasFile(value) {
      this.hasFile = value;
    },
    updateSuccessUploaded(value) {
      this.successUploaded = value;
      this.loading = false;
      this.reset();
      if (this.submitAction === "LOGGED_IN") {
        if (this.submitMessage) {
          toastAlert(this.submitMessage);
        }
        return goToRoute(this.submitRouteName, {}, {}, false);
      }
      if (this.submitAction === "SHOW_RESULT") {
        return goToRoute("result-registrations", {}, {}, false);
      }
    },
    reset() {
      Object.keys(this.form).forEach((key) => (this.form[key] = null));
      this.$v.$reset();
    },
    genderClicked(value) {
      this.form.gender = +value;
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const { password, nationalCode, name, family, birthDate } = this.form;
        const educationGrade = pathOr(null, ["id"], this.form.educationGrade);
        const sokonatCity = pathOr(null, ["id"], this.form.sokonatCity);
        const jobLevel = pathOr(null, ["id"], this.form.jobLevel);
        const jobCategory =
          pathOr(null, ["id"], this.form.jobCategory) === 8
            ? this.form.otherJobCategory
            : pathOr(null, ["caption"], this.form.jobCategory);
        const gender = this.form.gender;
        const response = await setPreRegister({
          password,
          nationalCode,
          name,
          family,
          birthDate,
          educationGrade,
          sokonatCity,
          jobLevel,
          jobCategory,
          gender,
        });
        const { action, routeName, resourceName, resourceValue, message } =
          response;
        this.resourceName = resourceName;
        this.resourceValue = resourceValue;
        this.submitAction = action;
        this.submitRouteName = routeName;
        this.submitMessage = message;

        if (!this.hasFile) {
          this.updateSuccessUploaded(true);
        } else {
          return; // wait for update success upload - break this code and continue processing into updateSuccessUploaded method
        }

        if (action === "LOGGED_IN") {
          toastAlert(message);
          return goToRoute(routeName, {}, {}, false);
        }
        if (action === "SHOW_RESULT") {
          return goToRoute("result-registrations", {}, {}, false);
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = this.hasFile;
      }
    },
    async fetchData() {
      // check exist current course
      if (!Object.keys(this.currentCourse).length) {
        this.$notify.warning(this.$lang.notExistCurrentCourseMessage);
        goToRoute("active-registrations", {}, {}, false);
      }

      this.form.username = this.preRegisterUsername;
      this.form.nationalCode = this.hasNationalCode
        ? this.nationalCodePreview
        : null;
    },
  },
};
</script>
